import { withBase } from '@utils/basePath'

export type FaviconLink = { href: string; rel: string; sizes: string; type: string }

const FAVICON_SIZES: Array<16 | 32 | 48 | 96 | 180 | 192> = [16, 32, 48, 96, 180, 192]

/**
 * `<link rel="icon">` entries for the active theme brand’s PNG favicons under `content/favicons/{themeBrand}/`.
 */
export function getFaviconLinksForThemeBrand(themeBrand: string): FaviconLink[] {
  return FAVICON_SIZES.map((s) => ({
    href: withBase(`/content/favicons/${themeBrand}/favicon-${s}x${s}.png`),
    rel: 'icon',
    sizes: `${s}x${s}`,
    type: 'image/png',
  }))
}
